export default __webpack_public_path__ + "static/media/star-builder.5ca673d2.png";